var BookmarkButton = require("app/Bookmarks/BookmarkButton"),
    ShareButton    = require("app/Sharing/ShareButton"),
    frameThrottle  = require("enyo-perf/utils").frameThrottle,
    get            = require("object-path").get,
    kind           = require("enyo/kind"),
    themeVars      = require("app/theme/variables");

require("./ActionButtons.less");
require("app/theme/styles/buttons/IconButton--icon-white.less");

module.exports = kind(/** @lends  app.ui.header.ActionButtons.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.ActionButtons",

    /**
     * @private
     */
    classes: "app-ui-header-action-buttons",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:    "bookmarkButton",
        kind:    BookmarkButton,
        classes: "app-ui-header-action-buttons__bookmark-button",
        theme:   "icon-white"
    }, {
        name:    "shareButton",
        kind:    ShareButton,
        classes: "app-ui-header-action-buttons__share-button",
        theme:   "icon-white"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * Update the contents of the header.
     *
     * @note When extending this method, put the changes before the call to the
     * super method, because this method will call a reflow at the end.
     * @public
     */
    update: function() {
        var data            = this.data || {},
            $bookmarkButton = this.$.bookmarkButton;

        if (!get(data, "show_meta_text", false)) {
            $bookmarkButton.set("mediaItem", data);
        }
        else {
            $bookmarkButton.set("mediaItem", null);
        }
        this.$.shareButton.set("mediaItem", data);
    },

    /**
     * @private
     */
    reflow: function() {
        var $bookmarkButton = this.$.bookmarkButton,
            $shareButton    = this.$.shareButton;

        if (["tiny", "smaller", "small"].includes(themeVars.formFactor)) {
            $bookmarkButton.set("showCaption", false);
            $shareButton.set("showCaption", false);
        }
        else if (["medium", "large"].includes(themeVars.formFactor)) {
            $bookmarkButton.set("showCaption", true);
            $shareButton.set("showCaption", true);
        }
    }

});
